import * as React from "react";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Box from "@mui/material/Box";
import AppDrawer from "../AppDrawer";
import MainOrder from "./MainOrder";

const mdTheme = createTheme();

const Order = () => {
  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />

        {/* Navbar and Sidebar Dashboard */}
        <AppDrawer title="Order" />

        {/* Box for Main */}
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === "light"
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: "100vh",
            overflow: "auto",
          }}
        >
          {/* Main Attribute */}
          <MainOrder />
        </Box>
      </Box>
    </ThemeProvider>
  );
};

export default Order;
